<template>
  <div class="not-logged-in">
    <img
      :src="srcSet('src', offlineMonsterImgs)"
      :srcset="srcSet('srcset', offlineMonsterImgs)"
      alt="">
    <p>Log in to your Luminary acount to save shows and create a playlist.</p>
    <router-link
      class="el-button btn-transparent"
      to="../signin">
      Log In
    </router-link>
  </div>
</template>
<script>
import offlineMonster1x from '../assets/images/art_monster_offline_1x.png';
import offlineMonster2x from '../assets/images/art_monster_offline_2x.png';
import offlineMonster3x from '../assets/images/art_monster_offline_3x.png';

export default {
  data() {
    return {
      offlineMonsterImgs: [offlineMonster1x, offlineMonster2x, offlineMonster3x],
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.not-logged-in {
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
  padding: 50px 0;
  img {
    max-width: 290px;
    margin-bottom: 24px;
  }
  p {
    margin-bottom: 24px;
  }
  .el-button {
    max-width: 102px;
    padding: 13px 25px;
    font-size: 18px;
    color: $black;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/LoginMessage.vue